import { ref } from 'vue';

const getVacationProfiles = () => {
    const vacationProfiles_error = ref(null);
    const vacationProfiles = ref(null);

    const loadVacationProfiles = async () => {
      try {
        let data = await fetch("/api/vacationprofiles");

        if (!data.ok) {
          throw Error("Can't load data");
        }

        vacationProfiles.value = await data.json();

        // console.log('costcentres', costcentres.value);
      } catch (err) {
        vacationProfiles_error.value = err.message;
      }
    };

    return { vacationProfiles, vacationProfiles_error, loadVacationProfiles};
}

export default getVacationProfiles;